import HomeSpotlightArticleSection from './HomeSpotlightArticleSection'

export default HomeSpotlightArticleSection
